export default {
  transaction: {
    title: 'Lịch sử giao dịch',
    select: 'Chọn',
    all: 'Tất cả',
    loading: 'Đang tải...',
    noMoreData: 'Không còn dữ liệu',
    mockSuccess: 'Mô phỏng thành công',
    mockFail: 'Mô phỏng thất bại',
    mockSuccessDone: 'Mô phỏng thành công hoàn tất',
    mockFailDone: 'Mô phỏng thất bại hoàn tất',
    mockFailed: 'Mô phỏng thất bại',
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    last3Days: '3 ngày qua',
    last7Days: '7 ngày qua',
    last15Days: '15 ngày qua',
    last30Days: '30 ngày qua',
    allTypes: 'Tất cả loại',
    deposit: 'Nạp',
    withdrawal: 'Rút tiền',
    withdrawalRefund: 'Hoàn tiền rút',
    bet: 'Cược',
    win: 'Thắng',
    manualAdd: 'Cộng thủ công',
    manualSubtract: 'Trừ thủ công',
    commission: 'Hoa hồng',
    bonus: 'Thưởng',
    vipUpgradeReward: 'Thưởng nâng cấp VIP',
    vipSalary: 'Lương VIP',
    gameOutPrincipal: 'Rút game - Gốc',
    gameOutBonus: 'Rút game - Thưởng',
    bonusTransferOut: 'Chuyển thưởng ra',
    allStats: 'Tất cả trạng thái',
    underReview: 'Đang xét duyệt',
    pendingPayout: 'Chờ chi trả',
    successful: 'Thành công',
    failed: 'Thất bại',
    cancelled: 'Đã hủy',
    processing: 'Đang xử lý',
  },
};
